import { DataTableColumn } from '@/components/ui/data-table-customized'
import { SLATemplate } from '@/modules/Service/types/sla'

export const getSLATemplateColumns = (): DataTableColumn<SLATemplate>[] => [
    {
        key: 'sla_template_id',
        title: 'ID',
        width: 80,
        render: (_value, row) => (
            <span className="font-mono text-xs text-muted-foreground">
                #{row.sla_template_id}
            </span>
        ),
    },
    {
        key: 'template_name',
        title: 'Template Name',
        width: 250,
        sortable: true,
        render: (_value, row) => (
            <div className="flex flex-col">
                <span className="font-medium">{row.template_name}</span>
                {row.template_description && (
                    <span className="text-xs text-muted-foreground truncate max-w-[200px]">
                        {row.template_description}
                    </span>
                )}
            </div>
        ),
    },
    {
        key: 'template_tier',
        title: 'Tier',
        width: 120,
        sortable: true,
        formatter: {
            type: 'options',
            options: [
                { value: 'bronze', label: 'BRONZE', color: 'warning' },
                { value: 'silver', label: 'SILVER', color: 'secondary' },
                { value: 'gold', label: 'GOLD', color: 'success' },
                { value: 'platinum', label: 'PLATINUM', color: 'info' },
                { value: 'custom', label: 'CUSTOM', color: 'primary' },
            ],
            size: 'sm',
        },
    },
    {
        key: 'uptime_guarantee',
        title: 'Uptime',
        width: 100,
        cellClassName: 'text-center',
        render: (_value, row) => (
            <span className="font-medium text-green-600">
                {row.uptime_guarantee}%
            </span>
        ),
    },
    {
        key: 'downtime_allowance_minutes',
        title: 'Downtime',
        width: 120,
        cellClassName: 'text-center',
        render: (_value, row) => (
            <span className="text-orange-600">
                {row.downtime_allowance_minutes} min
            </span>
        ),
    },
    {
        key: 'default_response_time',
        title: 'Response',
        width: 100,
        cellClassName: 'text-center',
        valueGetter: (row) => `${row.default_response_time} min`,
    },
    {
        key: 'default_resolution_time',
        title: 'Resolution',
        width: 100,
        cellClassName: 'text-center',
        valueGetter: (row) => `${row.default_resolution_time} min`,
    },
    {
        key: 'business_hours_only',
        title: 'Hours',
        width: 120,
        cellClassName: 'text-center',
        formatter: {
            type: 'chip',
            colorMap: {
                true: { label: 'Business', color: 'secondary' },
                false: { label: '24/7', color: 'primary' },
            },
        },
    },
    {
        key: 'is_active',
        title: 'Status',
        width: 100,
        cellClassName: 'text-center',
        formatter: {
            type: 'options',
            options: [
                { value: true, label: 'Active', color: 'success' },
                { value: false, label: 'Inactive', color: 'secondary' },
            ],
            showDot: true,
            variant: 'dot',
        },
    },
]
